<template>
  <div>
    <EntityStatistics
      :title="'POIs: Statistiken'"
      :name="'POIs'"
      :entityType="'poi'"
      :configAction="'getApiKeys'"
      :latestDataEndpoint="env.poi_api_client_url + 'poi'"
      :matomoEndpoint="'https://matomo.api.eo-heimat.de'"
      :matomoSiteId="isDevEnvironment ? 3 : 4"
      :matomoTokenAuth="'72d0c8747156029f020882bb77535ca1'"
      :overviewTitle="'Alle POIs'"
      :overviewLink="'/poi/statistics/overview'"
    />
  </div>
</template>

<script>
import EntityStatistics from "@/components/Statistics/EntityStatistics.vue";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "POIOverview",
  components: {
    EntityStatistics
  },
  async mounted() {
    await this.$store.dispatch("getCategoryTypes");
  },
  computed: {
    env() {
      return env;
    },
    isDevEnvironment() {
      return ["env.dev", "env.local"].some(env =>
        process.env.VUE_APP_ENV_PATH.includes(env)
      );
    }
  }
};
</script>
